"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileRow = function (_a) {
    var amount = _a.amount, winAmount = _a.winAmount, result = _a.result, placedAt = _a.placedAt, idx = _a.idx;
    var t = (0, next_intl_1.useTranslations)('translation');
    var status = result === 'WIN' ? ui_components_1.StatusType.success : ui_components_1.StatusType.error;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(idx % 2 === 0 ? styles_module_scss_1.default.odd : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.currency }, amount),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, winAmount)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('placedAt')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('status'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, placedAt),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_components_1.StatusText, { textAlign: "flex-start", status: status }, result)))));
};
exports.default = MobileRow;
